<template>
  <cos-modal
    v-model:visible="visible"
    :title="title"
    width="670px"
    :confirm-loading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :model="dataForm" ref="formRef" :rules="formRules" :wrapper-col="{ span: 24 }">
      <dc-form-item name="parentName" label="上级标签" :span="24">
        <a-input v-model:value="dataForm.parentName" :disabled="true" style="width: 100%" />
      </dc-form-item>
      <dc-form-item name="labelName" label="标签名称" :span="24">
        <CosInput v-model:value="dataForm.labelName" style="width: 100%" />
      </dc-form-item>
      <dc-form-item label="类型" name="labelType" :span="24">
        <CosSelect
          v-model:value="dataForm.labelType"
          :options="labelTypeEnum"
          placeholder="请选择"
          allowClear
          style="width: 100%"
        />
      </dc-form-item>
      <a-form-item name="sort" label="顺序" :span="24">
        <a-input v-model:value="dataForm.sort" style="width: 100%" />
      </a-form-item>
      <dc-form-item name="comment" label="备注" :span="24">
        <a-input v-model:value="dataForm.comment" style="width: 100%" />
      </dc-form-item>
    </a-form>
  </cos-modal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { cloneDeep } from 'lodash-es'
import { message as DcMessage } from '@dc-platform/dc-components'
import { saveLabel, updateLabel } from '@/api/yuntuSales/labelManage'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'

const labelTypeEnum = [
  {
    value: 0,
    label: '普通标签'
  },
  {
    value: 1,
    label: '特殊标签'
  }
]

const title = ref<string>()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const initForm = { parentId: -1, parentName: '无' }
const dataForm = ref<any>(cloneDeep(initForm))
const formRules: Record<string, Rule[]> = {
  labelName: [{ required: true, message: '请输入标签名称' }],
  labelType: [{ required: true, message: '请选择类型' }]
}

watch(
  () => visible.value,
  (val) => {
    if (!val) {
      formRef.value?.resetFields()
      dataForm.value = cloneDeep(initForm)
    }
  }
)

const init = (data: any, parent?: any) => {
  if (data) {
    title.value = '编辑'
    dataForm.value.parentId = data.parentId
    dataForm.value.parentName = data.parentName
    dataForm.value.labelName = data.name
    dataForm.value.labelType = data.labelType
    dataForm.value.status = data.status
    dataForm.value.sort = data.weight
    dataForm.value.comment = data.comment
    dataForm.value.appId = data.appId
    dataForm.value.labelId = data.id
  } else {
    title.value = '新增'
    if (parent) {
      dataForm.value.parentId = parent.id
      dataForm.value.parentName = parent.name
    }
  }
  visible.value = true
}

const emit = defineEmits(['fetch'])
const handleOk = () => {
  formRef.value?.validate().then(() => {
    loading.value = true
    const params = Object.assign({}, dataForm.value)
    if (dataForm.value.labelId) {
      updateLabel(params)
        .then(() => {
          DcMessage.success(`${title.value}成功`)
          formRef.value?.resetFields()
          visible.value = false
          emit('fetch')
        })
        .finally(() => {
          loading.value = false
        })
    } else {
      params.appId = 'cos_lbu'
      params.status = 0
      saveLabel(params)
        .then(() => {
          DcMessage.success(`${title.value}成功`)
          formRef.value?.resetFields()
          visible.value = false
          emit('fetch')
        })
        .finally(() => {
          loading.value = false
        })
    }
  })
}
const handleCancel = () => {
  formRef.value?.resetFields()
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'LabelEditModal' }
</script>

<style lang="scss" scoped></style>
